var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeletedTileIcon = function SvgDeletedTileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "red",
    fillRule: "nonzero",
    points: "2.16066017 0.0393398282 21.9606602 19.8393398 19.8393398 21.9606602 0.0393398282 2.16066017"
  }))));
};

export default SvgDeletedTileIcon;